import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { queryOptions } from '@tanstack/react-query';
import type { Admin } from '../types/admin.type';

export type GetAdminResponse = ApiResponse<Admin>;

export const getAdmin = async (id: string): Promise<GetAdminResponse> => {
  return await apiClient.get(`admin/${id}`);
};

export const GET_ADMIN_QUERY_KEY = 'admin';
export function getAdminQueryOptions(id: string) {
  return queryOptions({
    queryKey: [GET_ADMIN_QUERY_KEY, id],
    queryFn: () => getAdmin(id),
    enabled: !!id,
  });
}
